import { BaseWebComponentDataProvider } from '../../../framework/BaseWebComponentDataProvider';
import { ConsoleRequest, DataProviderType } from '../../../utils/request';
import { ScheduleItem, SchedulesMethod } from '../../webAccessControlSchedulerApp/types';
import { SchedulesResponse } from '../types';

export class WebAccessControlSchedulerFormBaseDataProvider extends BaseWebComponentDataProvider {
  private endpoint = 'WebAccessControlSchedules';
  private dataProviderType = DataProviderType.ENDPOINTS;

  public async getDataForView() {
    return {};
  }

  public async createRecords(records: Array<ScheduleItem>): Promise<SchedulesResponse> {
    return ConsoleRequest.createRequest<SchedulesResponse>({
      dataProviderType: this.dataProviderType,
      payload: {records: records},
      endpoint: this.endpoint,
      method: SchedulesMethod.CREATE_RECORDS,
    });
  }

  public async updateRecords(records: Array<ScheduleItem>): Promise<SchedulesResponse> {
    return ConsoleRequest.createRequest<SchedulesResponse>({
      dataProviderType: this.dataProviderType,
      payload: {records: records},
      endpoint: this.endpoint,
      method: SchedulesMethod.UPDATE_RECORDS,
    });
  }
}
